import { Outlet } from 'react-router-dom';

function RootLayout() {
  return (
    <div className="app-container">
      <Outlet />
    </div>
  );
}

export default RootLayout;
